// extracted by mini-css-extract-plugin
export default {"main":"Checkbox_main__Mai4w","interactive":"Checkbox_interactive__fI7P6","input":"Checkbox_input__raNYm","box":"Checkbox_box__NmwLd","text":"Checkbox_text__g4Bch"};